import React from 'react';
import FeeCalculator from './components/FeeCalculator';

const App: React.FC = () => {
  return (
    <div>
      <FeeCalculator />
    </div>
  );
};

export default App; 